
<ul>
    <li *ngFor="let user of users">
        <!-- {{user.username}} ({{user.firstName}} {{user.lastName}}) -->
        - <a (click)="deleteUser(user.id)" class="text-danger">Delete</a>
    </li>
</ul>
<p>WORKS HIOME</p>